import { sparklinePropsSchema } from '../component-catalog.js';
export const sparklineDefinition = {
    type: 'Sparkline',
    category: 'data',
    propsSchema: sparklinePropsSchema,
    isDataBacked: true,
    columnRefManifest: ['value'],
    needsMeasuredDims: true,
    description: 'Compact inline trend chart. Props: sourceDataset (required), mapping ({ value: string }), type? ("line" | "bar").',
};
//# sourceMappingURL=Sparkline.js.map